import { render, staticRenderFns } from "./TextTemplates.vue?vue&type=template&id=3248087a&scoped=true"
import script from "./TextTemplates.vue?vue&type=script&lang=js"
export * from "./TextTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3248087a",
  null
  
)

export default component.exports